
<a #topOfPage id="topOfPage"></a>
  <div class="page-content" page-content>

  <prism-ui-heading
    slot="consent-header"
    key-id="consent-header"
    font-size="lg" 
    font-weight="regular" 
    is-uppercase="false"
    variant="default"
  > 
    {{consentTitle}}
  </prism-ui-heading>

  <form id="consentForm" [formGroup]="consentForm" (ngSubmit)="onSubmit()">
    <prism-ui-container
    is-compact="false"
    key-id="consent-container"
    has-shadow="false"
    variant="default"
    has-no-border-radius="false"
  >  
      <div class="row">
        <prism-ui-copy
          key-id="consent-body"
        >
          <p [innerHTML]="consentBody"></p>
        </prism-ui-copy>
      </div>
      <prism-ui-form-field-select
            key-id="checkboxesKey"
            form-field-items-count="1"
            [isValid]="formControlUtilitiesService.setCheckboxFormValid(consentForm)"
        >
            <span slot="error">{{consentElement?.error}}</span>

        </prism-ui-form-field-select> 

        <prism-ui-checkbox
          formControlName="consent" 
          [formGroup]="consentForm" 
          key-id="consent"
          labelText="{{consentElement?.label}}"
          ngDefaultControl
          (prismUiCheckboxOnChange)="formControlUtilitiesService.toggleIndividualCheckbox($event, 'consent', consentForm)"
          [isValid]="formControlUtilitiesService.setCheckboxFormValid(consentForm)"
        ></prism-ui-checkbox>       
  </prism-ui-container>
  
  <div class="continueCancelButtonPadding">
    <app-continue-cancel class="bottomPadding" [primaryName]="consentPrimaryButton" (cancelEmitter)="onCancel()"></app-continue-cancel>
  </div>
  </form>
</div>


<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{modalContentHeading}}</prism-ui-heading
  >
  <prism-ui-copy
    slot="modal-body"
    key-id="cancel-modal"
  >
    {{modalContentBody}}
  </prism-ui-copy>
  <div slot="modal-footer">
    <div class="modalButtonStyling">
      <prism-ui-button 
        button-width="full"
        key-id="cancel-button"
        size="md"
        variant="secondary"
        type="button"
        is-icon-right-aligned="false"
        (click)="onCancelModal('prism-ui-modal-cancel-modal')"
      >Cancel</prism-ui-button>
      <prism-ui-button class="leftPaddingSmall"
        button-width="full"
        key-id="continue-button"
        size="md"
        variant="primary"
        type="button"
        is-icon-right-aligned="false"
        (click)="leaveAnyway()"
      >Leave Anyway</prism-ui-button>
    </div>    
</div>
</prism-ui-modal>